import client from "./client";

export const alertsApi = {
  listAlertRules: (scope: "mine" | "all" = "mine") =>
    client.get("/admin/alert-rules", { params: { scope } }),
  createAlertRule: (data: Record<string, unknown>) => client.post("/admin/alert-rules", data),
  updateAlertRule: (id: string, data: Record<string, unknown>) => client.patch(`/admin/alert-rules/${id}`, data),
  deleteAlertRule: (id: string) => client.delete(`/admin/alert-rules/${id}`),
  getAlertFirings: (id: string) => client.get(`/admin/alert-rules/${id}/firings`),
  evaluateAlertRule: (id: string) => client.post(`/admin/alert-rules/${id}/evaluate`),
};
